import createModelStore from "../../utils/createModelStore";
import Car from "../../services/Car";

const cars = createModelStore<Car.Model, "cars">("cars");

export default cars;
